var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-app", [
        _vm.agency != null
          ? _c("div", { staticClass: "dashboard-main-content" }, [
              _c("div", { staticClass: "container-fluid" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _c("form", { attrs: { id: "agencyDetailFrom" } }, [
                      _c("div", { staticClass: "form-box" }, [
                        _c("div", { staticClass: "form-content pb-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-end p-3",
                            },
                            [
                              _c("h3", { staticClass: "title" }, [_c("br")]),
                              _vm._v(" "),
                              _vm.panelRights["PANEL_INVOICE_ACTIONS"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "theme-btn",
                                      staticStyle: {
                                        "margin-right": "10px !important",
                                      },
                                      attrs: { type: "button" },
                                      on: {
                                        click: _vm.goToAgencyPaymentDetail,
                                      },
                                    },
                                    [_vm._v("Cari Hesap Detayına Git")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-content pb-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "row justify-content-between" },
                              [
                                _c("div", { staticClass: "col-lg-6" }, [
                                  _c("div", { staticClass: "card-item p-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "contact-form-action" },
                                      [
                                        _c(
                                          "h3",
                                          { staticClass: "title mb-3" },
                                          [_vm._v("Acente")]
                                        ),
                                        _vm._v(" "),
                                        _c("base-edit-input", {
                                          attrs: {
                                            label: "Adı",
                                            rules: "required",
                                          },
                                          model: {
                                            value: _vm.agency.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.agency, "name", $$v)
                                            },
                                            expression: "agency.name",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("base-edit-input", {
                                          attrs: { label: "Vergi Numarası" },
                                          model: {
                                            value: _vm.agency.taxNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.agency,
                                                "taxNumber",
                                                $$v
                                              )
                                            },
                                            expression: "agency.taxNumber",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.projectName === "miray"
                                          ? _c("base-edit-input", {
                                              attrs: { label: "Cari Kod" },
                                              model: {
                                                value: _vm.agency.currentCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.agency,
                                                    "currentCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "agency.currentCode",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("base-text-area-input", {
                                          attrs: { label: "Adres" },
                                          model: {
                                            value: _vm.agency.address,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.agency,
                                                "address",
                                                $$v
                                              )
                                            },
                                            expression: "agency.address",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-box d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "label-text" },
                                              [_vm._v("Web Servis Erişimi")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.agency.webServiceAccess,
                                                  expression:
                                                    "agency.webServiceAccess",
                                                },
                                              ],
                                              staticClass: "form-control ",
                                              staticStyle: { width: "5rem" },
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.agency.webServiceAccess
                                                )
                                                  ? _vm._i(
                                                      _vm.agency
                                                        .webServiceAccess,
                                                      null
                                                    ) > -1
                                                  : _vm.agency.webServiceAccess,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.agency
                                                        .webServiceAccess,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "webServiceAccess",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "webServiceAccess",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.agency,
                                                      "webServiceAccess",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-box d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "label-text" },
                                              [_vm._v("Parçalı Ödeme İmkanı")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.agency
                                                      .canTakePartialPayment,
                                                  expression:
                                                    "agency.canTakePartialPayment",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              staticStyle: { width: "5rem" },
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.agency
                                                    .canTakePartialPayment
                                                )
                                                  ? _vm._i(
                                                      _vm.agency
                                                        .canTakePartialPayment,
                                                      null
                                                    ) > -1
                                                  : _vm.agency
                                                      .canTakePartialPayment,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.agency
                                                        .canTakePartialPayment,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "canTakePartialPayment",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "canTakePartialPayment",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.agency,
                                                      "canTakePartialPayment",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "input-box d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "label-text" },
                                              [_vm._v("Çoklu Oda seçimi")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.agency
                                                      .canBookMultipleRooms,
                                                  expression:
                                                    "agency.canBookMultipleRooms",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              staticStyle: { width: "5rem" },
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.agency
                                                    .canBookMultipleRooms
                                                )
                                                  ? _vm._i(
                                                      _vm.agency
                                                        .canBookMultipleRooms,
                                                      null
                                                    ) > -1
                                                  : _vm.agency
                                                      .canBookMultipleRooms,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.agency
                                                        .canBookMultipleRooms,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "canBookMultipleRooms",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "canBookMultipleRooms",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.agency,
                                                      "canBookMultipleRooms",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.projectName === "selectum"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-box d-flex align-items-center",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "label-text" },
                                                  [
                                                    _vm._v(
                                                      "Kredi Kartı Ödeme İmkanı"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.agency
                                                          .canTakeCreditCardPayment,
                                                      expression:
                                                        "agency.canTakeCreditCardPayment",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  staticStyle: {
                                                    width: "5rem",
                                                  },
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.agency
                                                        .canTakeCreditCardPayment
                                                    )
                                                      ? _vm._i(
                                                          _vm.agency
                                                            .canTakeCreditCardPayment,
                                                          null
                                                        ) > -1
                                                      : _vm.agency
                                                          .canTakeCreditCardPayment,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.agency
                                                            .canTakeCreditCardPayment,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.agency,
                                                              "canTakeCreditCardPayment",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.agency,
                                                              "canTakeCreditCardPayment",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.agency,
                                                          "canTakeCreditCardPayment",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("base-select-input", {
                                          attrs: {
                                            label: "Market",
                                            rules: "required",
                                            "option-list": _vm.marketList,
                                          },
                                          model: {
                                            value: _vm.agency.marketId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.agency,
                                                "marketId",
                                                $$v
                                              )
                                            },
                                            expression: "agency.marketId",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.projectName === "miray"
                                          ? _c("base-select-input", {
                                              attrs: {
                                                label: "Sözleşme Tipi",
                                                rules: "required",
                                                "option-list": [
                                                  { id: "cash", name: "Nakit" },
                                                  {
                                                    id: "current",
                                                    name: "Cari",
                                                  },
                                                ],
                                              },
                                              model: {
                                                value: _vm.agency.agreementType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.agency,
                                                    "agreementType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "agency.agreementType",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.agency.id == null &&
                                        _vm.user != null
                                          ? _c("base-edit-input", {
                                              attrs: {
                                                label: "Email",
                                                rules: "required|email",
                                              },
                                              model: {
                                                value: _vm.user.email,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.email",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.agency.id == null &&
                                        _vm.user != null
                                          ? _c("base-edit-input", {
                                              attrs: {
                                                rules: "required|password",
                                                type: "password",
                                                label: "Password",
                                              },
                                              model: {
                                                value: _vm.user.password,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.user,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression: "user.password",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.agency.id != null
                                          ? _c("base-select-input", {
                                              attrs: {
                                                textkey: ["email"],
                                                label: "Admin",
                                                "option-list": _vm.userList,
                                              },
                                              model: {
                                                value: _vm.agency.masterUserId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.agency,
                                                    "masterUserId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "agency.masterUserId",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("base-text-area-input", {
                                          attrs: { label: "Banka Bilgileri" },
                                          model: {
                                            value: _vm.agency.taxAddress,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.agency,
                                                "taxAddress",
                                                $$v
                                              )
                                            },
                                            expression: "agency.taxAddress",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("base-text-area-input", {
                                          attrs: { label: "Muhasebe Notları" },
                                          model: {
                                            value: _vm.agency.accountantNotes,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.agency,
                                                "accountantNotes",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "agency.accountantNotes",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "btn-box mt-3" },
                                          [
                                            _vm.agency.id == null
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass: "theme-btn",
                                                    class: {
                                                      disabled: !_vm.formValid,
                                                    },
                                                    attrs: { type: "button" },
                                                    on: { click: _vm.create },
                                                  },
                                                  [_vm._v("Kaydet")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.agency.id != null
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass: "theme-btn",
                                                    class: {
                                                      disabled: !_vm.formValid,
                                                    },
                                                    attrs: { type: "button" },
                                                    on: { click: _vm.update },
                                                  },
                                                  [_vm._v("Güncelle")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.agency.id != null
                                  ? _c(
                                      "div",
                                      { staticClass: "col-lg-6" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "card-item p-3",
                                            style: !_vm.agency.active
                                              ? "background-color: #F55454FF;"
                                              : "",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "contact-form-action",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-box d-flex align-items-center flex",
                                                  },
                                                  [
                                                    _vm.agency.active
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                          },
                                                          [_vm._v("Aktif")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.agency.active
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "label-text",
                                                            staticStyle: {
                                                              color: "white",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Aktif Değil"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.agency.active,
                                                          expression:
                                                            "agency.active",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control ",
                                                      staticStyle: {
                                                        width: "5rem",
                                                      },
                                                      attrs: {
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          _vm.agency.active
                                                        )
                                                          ? _vm._i(
                                                              _vm.agency.active,
                                                              null
                                                            ) > -1
                                                          : _vm.agency.active,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.agency.active,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  _vm.agency,
                                                                  "active",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  _vm.agency,
                                                                  "active",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              _vm.agency,
                                                              "active",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "card-item p-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "contact-form-action",
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  { staticClass: "title" },
                                                  [_vm._v("Risk Limiti ")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "form-box" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "container",
                                                          },
                                                          [
                                                            _c(
                                                              "base-edit-input",
                                                              {
                                                                attrs: {
                                                                  rules:
                                                                    "required|min_value:1",
                                                                  type: "number",
                                                                  label:
                                                                    "Miktar",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.agency
                                                                      .riskLimit,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.agency,
                                                                        "riskLimit",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "agency.riskLimit",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("agency-credit"),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "card-item p-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "contact-form-action",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-box" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "container",
                                                          },
                                                          [
                                                            _c(
                                                              "base-select-input",
                                                              {
                                                                attrs: {
                                                                  optionList: [
                                                                    {
                                                                      name: "Sabit Oran",
                                                                      id: "fixed",
                                                                    },
                                                                    {
                                                                      name: "Dinamik Oran",
                                                                      id: "dynamic",
                                                                    },
                                                                  ],
                                                                  rules:
                                                                    "required",
                                                                  type: "text",
                                                                  label:
                                                                    "Komisyon Tipi",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.agency
                                                                      .commissionRateType,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.agency,
                                                                        "commissionRateType",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "agency.commissionRateType",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "base-edit-input",
                                                              {
                                                                attrs: {
                                                                  rules:
                                                                    "required|min_value:0",
                                                                  type: "number",
                                                                  label:
                                                                    _vm.agency
                                                                      .commissionRateType ===
                                                                    "fixed"
                                                                      ? "Komisyon Oranı"
                                                                      : "Standart Komisyon Oranı",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.agency
                                                                      .commissionRate,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.agency,
                                                                        "commissionRate",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "agency.commissionRate",
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-box d-flex align-items-center",
                                                              },
                                                              [
                                                                _c(
                                                                  "label",
                                                                  {
                                                                    staticClass:
                                                                      "label-text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Vergi Dahil Komisyon"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .agency
                                                                          .commissionIncludeTaxes,
                                                                      expression:
                                                                        "agency.commissionIncludeTaxes",
                                                                    },
                                                                  ],
                                                                  staticClass:
                                                                    "form-control ",
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "1px",
                                                                    "margin-bottom":
                                                                      "1px",
                                                                    width:
                                                                      "5rem",
                                                                  },
                                                                  attrs: {
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .agency
                                                                          .commissionIncludeTaxes
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .agency
                                                                              .commissionIncludeTaxes,
                                                                            null
                                                                          ) > -1
                                                                        : _vm
                                                                            .agency
                                                                            .commissionIncludeTaxes,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .agency
                                                                              .commissionIncludeTaxes,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.agency,
                                                                                "commissionIncludeTaxes",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.agency,
                                                                                "commissionIncludeTaxes",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.agency,
                                                                            "commissionIncludeTaxes",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.agency
                                                          .commissionRateType ===
                                                        "dynamic"
                                                          ? _c("v-data-table", {
                                                              staticClass:
                                                                "elevation-1",
                                                              attrs: {
                                                                headers:
                                                                  _vm.headers,
                                                                items:
                                                                  _vm.agencyCommissionRates,
                                                                "items-per-page": 5,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "top",
                                                                      fn: function () {
                                                                        return [
                                                                          _c(
                                                                            "v-toolbar",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  flat: "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-toolbar-title",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Dinamik Komisyon Oranları"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-divider",
                                                                                {
                                                                                  staticClass:
                                                                                    "mx-4",
                                                                                  attrs:
                                                                                    {
                                                                                      inset:
                                                                                        "",
                                                                                      vertical:
                                                                                        "",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-spacer"
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "v-dialog",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      "max-width":
                                                                                        "500px",
                                                                                    },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "activator",
                                                                                          fn: function (
                                                                                            ref
                                                                                          ) {
                                                                                            var on =
                                                                                              ref.on
                                                                                            var attrs =
                                                                                              ref.attrs
                                                                                            return [
                                                                                              _c(
                                                                                                "v-btn",
                                                                                                _vm._g(
                                                                                                  _vm._b(
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "mb-2",
                                                                                                      attrs:
                                                                                                        {
                                                                                                          color:
                                                                                                            "primary",
                                                                                                          dark: "",
                                                                                                        },
                                                                                                    },
                                                                                                    "v-btn",
                                                                                                    attrs,
                                                                                                    false
                                                                                                  ),
                                                                                                  on
                                                                                                ),
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "\n                                          Yeni Oran Yarat\n                                        "
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      false,
                                                                                      1052420132
                                                                                    ),
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm.dialog,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.dialog =
                                                                                            $$v
                                                                                        },
                                                                                      expression:
                                                                                        "dialog",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "v-card",
                                                                                    [
                                                                                      _c(
                                                                                        "v-card-title",
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-h5",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Dinamik Komisyon Oranı"
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "v-card-text",
                                                                                        [
                                                                                          _c(
                                                                                            "v-container",
                                                                                            [
                                                                                              _c(
                                                                                                "v-row",
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-col",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          cols: "12",
                                                                                                          sm: "6",
                                                                                                          md: "6",
                                                                                                        },
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "input-box",
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "label",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "label-text",
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                "Başlangıç Tarihi"
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                          _vm._v(
                                                                                                            " "
                                                                                                          ),
                                                                                                          _c(
                                                                                                            "input",
                                                                                                            {
                                                                                                              directives:
                                                                                                                [
                                                                                                                  {
                                                                                                                    name: "model",
                                                                                                                    rawName:
                                                                                                                      "v-model",
                                                                                                                    value:
                                                                                                                      _vm
                                                                                                                        .editedItem
                                                                                                                        .startDate,
                                                                                                                    expression:
                                                                                                                      "editedItem.startDate",
                                                                                                                  },
                                                                                                                ],
                                                                                                              staticClass:
                                                                                                                "form-control",
                                                                                                              attrs:
                                                                                                                {
                                                                                                                  id: "startDate",
                                                                                                                  type: "date",
                                                                                                                  placeholder:
                                                                                                                    "",
                                                                                                                },
                                                                                                              domProps:
                                                                                                                {
                                                                                                                  value:
                                                                                                                    _vm
                                                                                                                      .editedItem
                                                                                                                      .startDate,
                                                                                                                },
                                                                                                              on: {
                                                                                                                input:
                                                                                                                  function (
                                                                                                                    $event
                                                                                                                  ) {
                                                                                                                    if (
                                                                                                                      $event
                                                                                                                        .target
                                                                                                                        .composing
                                                                                                                    ) {
                                                                                                                      return
                                                                                                                    }
                                                                                                                    _vm.$set(
                                                                                                                      _vm.editedItem,
                                                                                                                      "startDate",
                                                                                                                      $event
                                                                                                                        .target
                                                                                                                        .value
                                                                                                                    )
                                                                                                                  },
                                                                                                              },
                                                                                                            }
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "input-box",
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "label",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "label-text",
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                "Komisyon Oranı"
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                          _vm._v(
                                                                                                            " "
                                                                                                          ),
                                                                                                          _c(
                                                                                                            "input",
                                                                                                            {
                                                                                                              directives:
                                                                                                                [
                                                                                                                  {
                                                                                                                    name: "model",
                                                                                                                    rawName:
                                                                                                                      "v-model",
                                                                                                                    value:
                                                                                                                      _vm
                                                                                                                        .editedItem
                                                                                                                        .commissionRate,
                                                                                                                    expression:
                                                                                                                      "editedItem.commissionRate",
                                                                                                                  },
                                                                                                                ],
                                                                                                              staticClass:
                                                                                                                "form-control",
                                                                                                              attrs:
                                                                                                                {
                                                                                                                  id: "commissionRate",
                                                                                                                  type: "number",
                                                                                                                  placeholder:
                                                                                                                    "",
                                                                                                                },
                                                                                                              domProps:
                                                                                                                {
                                                                                                                  value:
                                                                                                                    _vm
                                                                                                                      .editedItem
                                                                                                                      .commissionRate,
                                                                                                                },
                                                                                                              on: {
                                                                                                                input:
                                                                                                                  function (
                                                                                                                    $event
                                                                                                                  ) {
                                                                                                                    if (
                                                                                                                      $event
                                                                                                                        .target
                                                                                                                        .composing
                                                                                                                    ) {
                                                                                                                      return
                                                                                                                    }
                                                                                                                    _vm.$set(
                                                                                                                      _vm.editedItem,
                                                                                                                      "commissionRate",
                                                                                                                      $event
                                                                                                                        .target
                                                                                                                        .value
                                                                                                                    )
                                                                                                                  },
                                                                                                              },
                                                                                                            }
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "v-col",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          cols: "12",
                                                                                                          sm: "6",
                                                                                                          md: "6",
                                                                                                        },
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "input-box",
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "label",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "label-text",
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                "Bitiş Tarihi"
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                          _vm._v(
                                                                                                            " "
                                                                                                          ),
                                                                                                          _c(
                                                                                                            "input",
                                                                                                            {
                                                                                                              directives:
                                                                                                                [
                                                                                                                  {
                                                                                                                    name: "model",
                                                                                                                    rawName:
                                                                                                                      "v-model",
                                                                                                                    value:
                                                                                                                      _vm
                                                                                                                        .editedItem
                                                                                                                        .endDate,
                                                                                                                    expression:
                                                                                                                      "editedItem.endDate",
                                                                                                                  },
                                                                                                                ],
                                                                                                              staticClass:
                                                                                                                "form-control",
                                                                                                              attrs:
                                                                                                                {
                                                                                                                  id: "endDate",
                                                                                                                  type: "date",
                                                                                                                  placeholder:
                                                                                                                    "",
                                                                                                                },
                                                                                                              domProps:
                                                                                                                {
                                                                                                                  value:
                                                                                                                    _vm
                                                                                                                      .editedItem
                                                                                                                      .endDate,
                                                                                                                },
                                                                                                              on: {
                                                                                                                input:
                                                                                                                  function (
                                                                                                                    $event
                                                                                                                  ) {
                                                                                                                    if (
                                                                                                                      $event
                                                                                                                        .target
                                                                                                                        .composing
                                                                                                                    ) {
                                                                                                                      return
                                                                                                                    }
                                                                                                                    _vm.$set(
                                                                                                                      _vm.editedItem,
                                                                                                                      "endDate",
                                                                                                                      $event
                                                                                                                        .target
                                                                                                                        .value
                                                                                                                    )
                                                                                                                  },
                                                                                                              },
                                                                                                            }
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "v-card-actions",
                                                                                        [
                                                                                          _c(
                                                                                            "v-spacer"
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-btn",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "blue darken-1",
                                                                                                  text: "",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  _vm.close,
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "\n                                            Cancel\n                                          "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "v-btn",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "blue darken-1",
                                                                                                  text: "",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  _vm.save,
                                                                                              },
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "\n                                            Save\n                                          "
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                      proxy: true,
                                                                    },
                                                                    {
                                                                      key: "item.commissionRate",
                                                                      fn: function (
                                                                        ref
                                                                      ) {
                                                                        var item =
                                                                          ref.item
                                                                        return [
                                                                          _c(
                                                                            "tr",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    " +
                                                                                  _vm._s(
                                                                                    item.commissionRate
                                                                                  ) +
                                                                                  "\n                                  "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                    {
                                                                      key: "item.startDate",
                                                                      fn: function (
                                                                        ref
                                                                      ) {
                                                                        var item =
                                                                          ref.item
                                                                        return [
                                                                          _c(
                                                                            "tr",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "ddMMyyyy"
                                                                                    )(
                                                                                      item.startDate
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                  "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                    {
                                                                      key: "item.endDate",
                                                                      fn: function (
                                                                        ref
                                                                      ) {
                                                                        var item =
                                                                          ref.item
                                                                        return [
                                                                          _c(
                                                                            "tr",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "ddMMyyyy"
                                                                                    )(
                                                                                      item.endDate
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                  "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                    {
                                                                      key: "item.actions",
                                                                      fn: function (
                                                                        ref
                                                                      ) {
                                                                        var item =
                                                                          ref.item
                                                                        return [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.deleteItem(
                                                                                      item
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                    mdi-delete\n                                  "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  3490942490
                                                                ),
                                                            })
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panels",
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c("v-expansion-panel-header", [
                                      _vm._v(
                                        "\n                            Rezervasyonlar\n                          "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-expansion-panel-content", [
                                      _vm.agency.id != null
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-12" },
                                              [
                                                _c("agency-booking-list", {
                                                  attrs: {
                                                    "booking-list":
                                                      _vm.bookingList,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panels",
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c("v-expansion-panel-header", [
                                      _vm._v(
                                        "\n                            Hareketler\n                          "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-expansion-panel-content", [
                                      _vm.agency.id != null
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-12" },
                                              [_c("agency-transaction-list")],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panels",
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c("v-expansion-panel-header", [
                                      _vm._v(
                                        "\n                            Ödemeler\n                          "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-expansion-panel-content", [
                                      _vm.agency.id != null
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-12" },
                                              [_c("agency-payments-list")],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panels",
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c("v-expansion-panel-header", [
                                      _vm._v(
                                        "\n                            Çalışanlar\n                          "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-expansion-panel-content", [
                                      _vm.agency.id != null
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-12" },
                                              [_c("agency-user-list")],
                                              1
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", [_c("agency-user-detail", { ref: "agencyUser" })], 1),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }